import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { ISubjectCreateRequest } from "../../../common/types";
import api from "../../../common/api";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";

function CreateSubjectModal({ show, onHide, onSubjectCreate }: any) {
  const [name, setName] = useState("");

  const createSubject = async (subject: ISubjectCreateRequest) => {
    try {
      const response = await api.post("/subjects/", subject);
      toast.success("Predmet dodan");
      onSubjectCreate(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  async function handleCreateSubject() {
    const subject = {
      name: name,
    };

    await createSubject(subject);
    onHide();
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Dodaj predmet</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">
            Naziv
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            onChange={(e) => setName(e.target.value)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" onClick={onHide}>
          Odustani
        </Button>
        <Button onClick={handleCreateSubject}>Dodaj</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateSubjectModal;
